import React, { Component } from "react";

import { HStack } from "@formant/ui/component/common/HStack";
import { Icon } from "@formant/ui/component/common/Icon";

import * as styles from "./WarningMessage.scss";

export interface IWarningMessageProps {
    className?: string;
    children?: React.ReactNode;
}

export class WarningMessage extends Component<IWarningMessageProps> {
    public render() {
        const { children } = this.props;
        return (
            <HStack className={styles["warning-message"]}>
                <Icon className={styles.icon} name="warning" size="48" />
                {children}
            </HStack>
        );
    }
}
